<template>
  <div>
    <div class="title">
      <div class="back iconfont iconfanhui" @click="$router.go(-1)"></div>
      <div class="input"><van-search placeholder="请输入搜索关键词" v-model="value" @keypress="submit"/></div>
    </div>
    <div class="body">
      <div class="head">
        <div class="left">历史记录</div>
        <div class="clear" @click="clear">清除</div>
      </div>
      <div class="record">
        <ul>
          <li v-for="(item,index) in searchList" :key="index">{{item}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { Button,Search } from 'vant'
import Vue from 'vue'
Vue.use(Button).use(Search)
export default {
  data(){
    return{
      value:'',
      searchList:[]
    }
  },
  methods:{
    // 回车键
    submit:function(e){
      if (event.keyCode == 13) { //enter键
          event.preventDefault(); //禁止默认事件（默认是换行） 
          let arr= localStorage.getItem("ipad_search_history");
          if(arr != null){
              arr = JSON.parse(arr);
              let i =0;
              for(i;i<arr.length;i++){
                if(arr[i]==e.target.value){
                  break
                };
              }
              if(i==arr.length){
                let arr2= [e.target.value].concat(arr)
                localStorage.setItem("ipad_search_history",JSON.stringify(arr2))
                arr2.length >20 ? arr2.pop() : "" ;
              }
          }else{
              localStorage.setItem("ipad_search_history",JSON.stringify([e.target.value]))
          }
          this.$router.replace({
            path: "/searchresult",
            query: {
              //路由传参时push和query搭配使用 ，作用是传递参数
              tag:"搜索结果",
              search: e.target.value
            }
          });
      } 
    },
    // 清空
    clear(){
      localStorage.removeItem("ipad_search_history");
      this.searchList=[];
    },
    init(){
      let arr= localStorage.getItem("ipad_search_history");
      arr != null ? this.searchList=JSON.parse(arr) : "" ;
    }
  },
  created(){
    this.init();
  }
  
}
</script>
<style lang="scss" scoped>
  .title{
    position: relative;
    height:44px;
    line-height: 44px;
    padding: 0 14px;
    background:rgba(255,255,255,1);
    .back{
      position: absolute;
      top: 0px;
      left: 10px;
      width: 44px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      font-size: 20px;
    }
    .input{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 5px;
      width:427px;
      height:33px;
      background:rgba(237,237,237,1);
      border-radius:4px;
    }
  }
  .body{
    padding: 8px;
    .head{
      display: flex;
      justify-content: space-between;
      line-height: 48px;
      .left{
        font-size:12px;
        font-family:PingFangSC-Light;
        font-weight:bold;
        color:rgba(137,137,137,1);
        line-height: 48px;
      }
      .clear{
        width:96px;
        height:29px;
        border:1px solid rgba(120,119,127,1);
        border-radius:4px;
        text-align: center;
        line-height: 29px;
        font-size:14px;
        font-family:PingFangSC-Light;
        font-weight:300;
        color:#3E3E3E;
      }
    }
    // 历史记录
    .record{
      ul{
        display: flex;
        flex-flow: wrap;
        list-style: none;
        li{
          padding: 0 25px;
          font-size:16px;
          font-family:PingFangSC-Light;
          font-weight:bold;
          color:#ccc;
          line-height:48px;
        }
      }
    }
  }
</style>
<style>
  body{
    background:rgba(250,250,250,1);
  }
  .van-search{
    width: 100%;
    padding: 0;
  }
  .van-cell{
    padding: 0;
  }
</style>
<style scoped>

</style>




